import { Component, OnInit, Output, EventEmitter, Inject, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { AdvancedSortableDirective, SortEvent } from '../../shared/directive/advanced-sortable.directive';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DecimalPipe } from '@angular/common'; 
import { UserService } from '../../core/services/pos-services/usuario.service';
import { global } from '../../core/services/pos-services/api.global';
import { ProductoService } from 'src/app/core/services/pos-services/producto.service';
import { ExcelService } from '../../core/services/pos-services/excel.service';
import { AdvancedService } from './advanced.service';
import {ProductMin} from '../../core/models/pos.models/minstock'
import { Observable } from 'rxjs';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  providers: [UserService, ProductoService, AdvancedService, DecimalPipe]
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  @ViewChildren(AdvancedSortableDirective) headers: QueryList<AdvancedSortableDirective>;
  public userlocalstg;
  public nimage;
  public url:string;
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  nuser:string; idlogusr: number; vnotifica:number=0;
  // Table data
  minProdData: ProductMin[];
  tableData: ProductMin[];
  hideme: boolean[] = [];
  tables$: Observable<ProductMin[]>;
  total$: Observable<number>;

  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private authService: AuthenticationService,
              private authFackservice: AuthfakeauthenticationService,
              public languageService: LanguageService,
              public translate: TranslateService,
              public _cookiesService: CookieService,
              private _userService: UserService,
              private _productoService: ProductoService,
              public service: AdvancedService,
              private modalService: NgbModal,
              private excelService: ExcelService
              ) {
    this.url = global.url;
    this.userlocalstg = this._userService.getIdentity();
    this.nuser = this.userlocalstg.usr[0].fcus_nombre;
    this.idlogusr = this.userlocalstg.usr[0].fcus_id;
    this.imgPerfil();
    this.getProductosMin();
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }
  largeModalProdMin(largeDataModal: any) {
    this.modalService.open(largeDataModal, { size: 'xl', centered: true });
  }
  exportToExcel(): void {
    this.excelService.generateExcel(this.minProdData, 'Reporte_de_Productos_Stock_Minimo');
  }
  getProductosMin(){
    this._productoService.getStockMin().subscribe(
      response => {
        if(response.status == 'Success'){
          this.vnotifica+=1;
          
          if(response.type == 'Ok'){
            this.minProdData = response.product;
            this.tableData = this.minProdData;
            for (let i = 0; i <= this.tableData.length; i++) {
              this.hideme.push(true);
            }
            this.service.upTable$ = this.minProdData;
            this.tables$ = this.service.tables$;
            this.total$ = this.service.total$;
          }
        }
      },
      error => {
        console.log(error);
      });
  }
  
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  imgPerfil(){
    this.nimage = this.url+"usr_showima/"+this.idlogusr;
  }
  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }
  changeValue(i) {
    this.hideme[i] = !this.hideme[i];
  }
}
